<template>
  <div
    v-if="opened"
    data-trava-rolagem
    class="modal fade show"
    tabindex="-1"
    role="dialog"
    :key="refreshCounter"
    aria-labelledby="standard-modalLabel"
    aria-modal="true"
    :style="{ display: 'unset', borderRadius: 'var(--ct-modal-inner-border-radius)' }"
  >
    <div class="modal-consulte-bg" :key="refreshCounter" />
    <div class="modal-dialog modal-dialog-centered" :style="{ maxWidth: customWidth, zIndex: 1055 }">
      <div class="modal-content" :style="{ height: customHeight }">
        <div class="modal-header">
          <slot name="header">
            <h4 class="modal-title">Título do modal</h4>
          </slot>
          <button type="button" class="btn-close" @click="onCloseButton" />
        </div>
        <div class="modal-body">
          <slot name="content" />
        </div>
        <div class="modal-footer">
          <slot name="actions">
            <button type="button" class="btn btn-light" @click="close">Fechar</button>
          </slot>
        </div>
        <div v-if="loading" class="modal-loading-overlay">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// Trava a rolagem da página enquanto houver modal aberto e visível (elementos com data-trava-rolagem). Lê a página
// em vez de contar aberturas: o estado não tem como desencontrar e deixar a página presa sem rolagem.
// Quem rola a tela é o html (o CSS do projeto põe overflow nele) e o tema força overflow-y: auto !important no body,
// por isso os dois e com important. Este modal não usa o JS do Bootstrap, que faria isso sozinho.
function atualizarTravaRolagem() {
  const html = document.documentElement;
  const body = document.body;
  const aberto = Array.from(document.querySelectorAll('[data-trava-rolagem]')).some((el) => el.getClientRects().length > 0);
  if (aberto === (html.style.getPropertyValue('overflow-y') === 'hidden')) return;
  if (aberto) {
    // Sem a barra de rolagem a tela de trás alargaria: o espaço dela vira margem.
    const barra = window.innerWidth - html.clientWidth;
    html.style.setProperty('overflow-y', 'hidden', 'important');
    body.style.setProperty('overflow-y', 'hidden', 'important');
    if (barra > 0) body.style.setProperty('padding-right', `${barra}px`, 'important');
  } else {
    html.style.removeProperty('overflow-y');
    body.style.removeProperty('overflow-y');
    body.style.removeProperty('padding-right');
  }
}
export default defineComponent({
  name: 'ModalConsulte',
  emits: ['closeRequest'],
  data() {
    return {
      opened: false,
      refreshCounter: 0
    };
  },
  props: {
    width: {
      String,
      default: ''
    },
    height: {
      String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    // Quando true, o "X" do header apenas avisa (closeRequest) e NÃO fecha: quem decide fechar é o pai
    // (ex.: telas que precisam exportar/salvar algo antes de o conteúdo do modal ser desmontado).
    interceptarFechamento: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // flush post: confere a página depois que o modal entrou ou saiu do DOM.
    opened: {
      handler() {
        atualizarTravaRolagem();
      },
      flush: 'post'
    }
  },
  // Tela desmontada com o modal aberto (ex.: troca de rota): o modal já saiu do DOM, a página destrava.
  unmounted() {
    atualizarTravaRolagem();
  },
  methods: {
    onCloseButton() {
      if (this.interceptarFechamento) {
        this.$emit('closeRequest');
        return;
      }
      this.close();
    },
    open() {
      this.refreshCounter += 1;
      this.opened = true;
    },
    close() {
      this.refreshCounter += 1;
      this.opened = false;
    }
  },
  computed: {
    customWidth(): string | undefined {
      return this.width;
    },
    customHeight(): string | undefined {
      return this.height;
    }
  }
});
</script>
<style scoped>
/* A rolagem de dentro do modal (grid, lista) não passa para a página de trás quando chega no fim. */
.modal {
  overscroll-behavior: contain;
}
.modal-consulte-bg {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  width: 100%;
  height: 100%;
  background-color: #77777790;
}
.modal-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--ct-modal-inner-border-radius);
  /* Sem fundo, o spinner se perde sobre o conteudo (ex.: a imagem do croqui). */
  background-color: rgba(255, 255, 255, 0.55);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}

html[data-theme='dark'] .modal-loading-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
